import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IMarketplaceInsightTemplateInstallRequest } from "@gtmhub/insights";
import { IMarketplaceInsightTemplateInstallResponse } from "@gtmhub/insights/models/models";
import { RequestConfig } from "@webapp/core/abstracts/models/request-config.model";
import { BaseFacade } from "@webapp/core/abstracts/services/base-facade.service";
import { MarketplaceInsightTemplate, MarketplaceInsightTemplateDTO } from "@webapp/data-story/models/marketplace-facade.models";
import { MarketplaceApiService } from "@webapp/data-story/services/marketplace-facade/marketplace-api.service";
import { MarketplaceState } from "@webapp/data-story/services/marketplace-facade/marketplace-state.service";

@Injectable({
  providedIn: "root",
})
export class MarketplaceFacade extends BaseFacade<MarketplaceInsightTemplate, MarketplaceInsightTemplateDTO, MarketplaceState, MarketplaceApiService> {
  constructor(state: MarketplaceState, api: MarketplaceApiService) {
    super(state, api);
  }

  public installMarketplaceInsightTemplates$(templates: IMarketplaceInsightTemplateInstallRequest[]): Observable<IMarketplaceInsightTemplateInstallResponse> {
    return this.post$<IMarketplaceInsightTemplateInstallResponse>(templates, {
      ...new RequestConfig(),
      url: this.apiService.getMarketplaceInsightTemplateInstallEndpoint(),
    });
  }
}
